import * as types from '../../../../types/masters/metalPurity/fgPurity/fgPurityTypes';
import * as api from '../../../../../api/masters/metalPurity/fgPurity/fgPurityApi';

export const fetchFGPurities = () => async (dispatch) => {
  dispatch({ type: types.FETCH_FG_PURITY_REQUEST });
  try {
    const data = await api.fetchFGPurities();
    dispatch({ type: types.FETCH_FG_PURITY_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: types.FETCH_FG_PURITY_FAILURE, payload: error.message });
  }
};

export const addFGPurity = (fgPurity) => async (dispatch) => {
  try {
    const res = await api.addFGPurity(fgPurity);
    dispatch({ type: types.ADD_FG_PURITY_SUCCESS, payload: res });
    dispatch(fetchFGPurities());
  } catch (error) {
    dispatch({ type: types.FG_PURITY_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const updateFGPurity = (id, fgPurity) => async (dispatch) => {
  try {
    console.log('Updating FG Purity with ID:', id, 'Data:', fgPurity);
    const res = await api.updateFGPurity(id, fgPurity);
    console.log('Update response:', res);
    dispatch({ type: types.UPDATE_FG_PURITY_SUCCESS, payload: res });
    dispatch(fetchFGPurities());
  } catch (error) {
    console.error('Update error:', error);
    dispatch({ type: types.FG_PURITY_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const deleteFGPurity = (id) => async (dispatch) => {
  try {
    await api.deleteFGPurity(id);
    dispatch({ type: types.DELETE_FG_PURITY_SUCCESS, payload: id });
    dispatch(fetchFGPurities());
  } catch (error) {
    dispatch({ type: types.FG_PURITY_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const setFGPurityEdit = (fgPurity) => ({
  type: types.SET_FG_PURITY_EDIT,
  payload: fgPurity,
});

export const clearFGPurityEdit = () => ({
  type: types.CLEAR_FG_PURITY_EDIT,
}); 